var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_vm._t("default"),_c('svg',{staticClass:"link-underline"},[_c('line',{attrs:{"x1":"0","x2":"100%"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }